import { useCallback, useEffect, useState } from "react";
import { CampaignServiceError, listCampaignPrograms } from "../api";
import { ProgramListItem } from "../types";

interface UseCampaignProgramsResult {
  data: ProgramListItem[];
  isLoading: boolean;
  reload: () => Promise<void>;
}

export function useCampaignPrograms(
  campaignId: string,
): UseCampaignProgramsResult {
  const [data, setData] = useState<ProgramListItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const loadPrograms = useCallback(async () => {
    if (!campaignId) {
      setData([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    try {
      const response = await listCampaignPrograms(campaignId);
      setData(response.programs ?? []);
    } catch (error) {
      if (error instanceof CampaignServiceError || error instanceof Error) {
        setData([]);
      } else {
        setData([]);
      }
    } finally {
      setIsLoading(false);
    }
  }, [campaignId]);

  useEffect(() => {
    void loadPrograms();
  }, [loadPrograms]);

  return {
    data,
    isLoading,
    reload: loadPrograms,
  };
}
